<template>
  <section class="auth section container" style="padding-top:120px">
    <div class="auth-card glass">
      <h1 class="h1 auth-title">登入</h1>
      <p class="lead auth-sub">請使用 Email 登入以觀看課程</p>

      <!-- ✅ 修正：@submit.prevent="handleLogin" -->
      <form class="auth-form" @submit.prevent="handleLogin">
        <label class="label">電子郵箱</label>
        <input
          v-model.trim="email"
          type="email"
          class="input"
          placeholder="you@example.com"
          required
        />

        <label class="label">密碼</label>
        <input
          v-model="password"
          type="password"
          class="input"
          placeholder="••••••••"
          required
        />

        <!-- ✅ 顯示錯誤訊息 -->
        <p v-if="errorMsg" class="error-msg">{{ errorMsg }}</p>

        <!-- ✅ loading 狀態 -->
        <button
          class="btn btn--primary auth-btn"
          type="submit"
          :disabled="loading"
        >
          {{ loading ? '登入中...' : '登入' }}
        </button>
      </form>

      <p class="muted auth-foot">
        沒有帳號？
        <router-link to="/register" class="auth-link">立即註冊</router-link>
        <span class="sep">/</span>
        <router-link to="/forgot" class="auth-link">忘記密碼</router-link>
      </p>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { apiLogin } from '@/utils/auth'

const router = useRouter()
const route = useRoute()

const email = ref('')
const password = ref('')
const loading = ref(false)
const errorMsg = ref('')

async function handleLogin() {
  errorMsg.value = ''
  if (!email.value || !password.value) {
    errorMsg.value = '請輸入 Email 與密碼'
    return
  }
  loading.value = true
  try {
    const res = await apiLogin({
      email: email.value.trim(),
      password: password.value
    })

    if (res?.ok) {
      const redirect =
        typeof route.query.redirect === 'string'
          ? route.query.redirect
          : '/courses'
      router.push(redirect)
    } else {
      errorMsg.value = '登入失敗，請稍後再試'
    }
  } catch (err) {
    const e = err?.payload?.error
    if (e === 'BAD_CREDENTIALS') {
      const left = err?.payload?.attempts_left
      errorMsg.value =
        left != null ? `帳密錯誤，剩餘嘗試 ${left} 次` : '帳密錯誤'
    } else if (e === 'ACCOUNT_LOCKED') errorMsg.value = '您的帳號已被暫時鎖定'
    else if (e === 'USER_DISABLED') errorMsg.value = '帳號已停用'
    else errorMsg.value = '登入失敗，請稍後再試'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.auth {
  display: grid;
  place-items: center;
}
.auth-card {
  width: min(520px, 92vw);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 18px;
  padding: 26px 22px 20px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
}
.auth-title {
  margin: 0 0 8px;
}
.auth-sub {
  margin: 0 0 18px;
  opacity: 0.9;
}
.auth-form {
  display: grid;
  gap: 10px;
}
.auth-btn {
  width: 100%;
  margin-top: 8px;
}
.auth-foot {
  margin-top: 12px;
}
.auth-link {
  text-decoration: underline;
}
.error-msg {
  color: #f87171;
  font-size: 14px;
  margin: 4px 0 0;
}
</style>
